module.exports = __webpack_public_path__ + "media/leave-button.b4dd7bf0.mp3";